import axios from 'axios';
import config from '../../config'; // Asegúrate de que el path sea correcto

const baseUrl = config.baseUrl;
const endpoint = '/api/subir-pdf-patti';

// Crear una instancia de Axios con configuración base
const api = axios.create({
  baseURL: baseUrl,
});

// Función para subir archivos usando FormData
export const postSoportePatti = async (formData, id) => {
  try {
    
        // Agregar el id_documento al FormData
    formData.append('id_documento', id.toString());
    // Usar la instancia api en lugar de axios.post directamente
    const response = await api.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error al subir archivos:', error.response?.data || error.message);
    throw error;
  }
};
